/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Type_LabelInputs */

const en_admin_resources_resource_type_label = /** @type {(inputs: Admin_Resources_Resource_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What type of resource is this?`)
};

const de_admin_resources_resource_type_label = /** @type {(inputs: Admin_Resources_Resource_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um welche Art von Ressource handelt es sich?`)
};

const es_admin_resources_resource_type_label = /** @type {(inputs: Admin_Resources_Resource_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿De qué tipo de recurso se trata?`)
};

const fr_admin_resources_resource_type_label = /** @type {(inputs: Admin_Resources_Resource_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De quel type de ressource s'agit-il ?`)
};

/** @type {(inputs: Admin_Resources_Resource_Type_LabelInputs) => LocalizedString} */
const it_admin_resources_resource_type_label = en_admin_resources_resource_type_label;

/** @type {(inputs: Admin_Resources_Resource_Type_LabelInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_type_label = en_admin_resources_resource_type_label;

/** @type {(inputs: Admin_Resources_Resource_Type_LabelInputs) => LocalizedString} */
const pl_admin_resources_resource_type_label = en_admin_resources_resource_type_label;

/** @type {(inputs: Admin_Resources_Resource_Type_LabelInputs) => LocalizedString} */
const hu_admin_resources_resource_type_label = en_admin_resources_resource_type_label;

/** @type {(inputs: Admin_Resources_Resource_Type_LabelInputs) => LocalizedString} */
const ro_admin_resources_resource_type_label = en_admin_resources_resource_type_label;

/**
* | output |
* | --- |
* | "What type of resource is this?" |
*
* @param {Admin_Resources_Resource_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_type_label = /** @type {((inputs?: Admin_Resources_Resource_Type_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Type_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_type_label(inputs)
	if (locale === "de") return de_admin_resources_resource_type_label(inputs)
	if (locale === "es") return es_admin_resources_resource_type_label(inputs)
	if (locale === "fr") return fr_admin_resources_resource_type_label(inputs)
	if (locale === "it") return it_admin_resources_resource_type_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_type_label(inputs)
	if (locale === "pl") return pl_admin_resources_resource_type_label(inputs)
	if (locale === "hu") return hu_admin_resources_resource_type_label(inputs)
	return ro_admin_resources_resource_type_label(inputs)
});
export { admin_resources_resource_type_label as "admin.resources.resource_type_label" }